import { PlatformIconWrapper } from "../platformIconWrapper/PlatformIconWrapper.tsx";
import { PlatformItemType } from "../../../../../../../../../stores/types/profileTypes.tsx";
import { UsernameItem } from "../../../../../../../../../stores/types/brandSocialHandlesTypes.tsx";
import { PlatformInputWrapper } from "../platformInputWrapper/PlatformInputWrapper.tsx";
import { ValidateBodyType } from "../../../../dataType.ts";
import { RevIconButton } from "@revmatics/catalyst";
import { faTrash } from "@fortawesome/pro-light-svg-icons";

type Props = {
  platforms: PlatformItemType[];
  selected?: number;
  handleSelect: (platformId: number) => void;
  disabled?: number[];
  platformUsernames?: UsernameItem[];
  handleAddInput?: () => void;
  handleRemove?: () => void;
  handleRemoveInput?: (usernameId: number) => void;
  handleToValidate?: (data: ValidateBodyType) => void;
  displayTrash?: boolean;
};

export const PlatformWrapper = ({
  platforms,
  selected,
  handleSelect,
  disabled = [],
  platformUsernames,
  handleRemove,
  handleAddInput,
  handleRemoveInput,
  handleToValidate,
  displayTrash,
}: Props) => {
  return (
    <div className="rounded-lg border border-monochrome-200 w-full">
      <div
        className={`rounded-t-lg py-2 px-4 grid grid-cols-[1fr_40px] gap-2 items-start ${platformUsernames ? "border-b border-monochrome-200" : ""} `}
      >
        <div>
          <p className="typography-body-sm text-monochrome-900">
            Select platform
          </p>
          <div className="mt-2 flex gap-2 ">
            {platforms.map((platform) => (
              <PlatformIconWrapper
                key={`platform-icon-wrapper-${selected || 0}-${platform.id}`}
                platform={platform}
                selected={platform.id === selected}
                disabled={
                  platform.id !== selected && disabled.includes(platform.id)
                }
                disabledExistUsername={platformUsernames?.some(
                  (item) => item.status === "valid",
                )}
                handleSelect={() => handleSelect(platform.id)}
              />
            ))}
          </div>
        </div>
        {displayTrash && (
          <RevIconButton
            icon={faTrash}
            size="xl"
            iconSize="small"
            handleClick={handleRemove}
          />
        )}
      </div>
      {platformUsernames &&
        handleAddInput &&
        handleRemoveInput &&
        selected &&
        handleToValidate && (
          <div className="rounded-b-lg p-4 bg-monochrome-25 space-y-2">
            {platformUsernames.map((username, index) => (
              <PlatformInputWrapper
                key={`platform-icon-wrapper-${username.id}`}
                trashDisplay={
                  index > 0 || (index === 0 && platformUsernames.length > 1)
                }
                plusDisplay={platformUsernames.length - 1 === index}
                username={username}
                handleAdd={handleAddInput}
                handleRemove={() => handleRemoveInput(username.id)}
                handleToValidate={(value: string) =>
                  value !== username.username &&
                  handleToValidate({
                    platformId: selected,
                    usernameId: username.id,
                    value: value,
                    mode: username.mode,
                  })
                }
              />
            ))}
          </div>
        )}
    </div>
  );
};
